import moment from 'jalali-moment';
import React from 'react'
import PersianNumber from '../../shared/PersianNumber';

const PaymentTable = ({reserveinfodetail,inforesidencedetail}) => {
  
  return (
    <div className='PaymentTable'>
        <div className='d-flex-space mb-[24px]'>
            <p>هر شب اقامت</p>
            <div>
          <PersianNumber number={inforesidencedetail.price} /> تومان
            </div>
        </div>
        <div className='d-flex-space mb-[24px]'>
            <p>{reserveinfodetail.count_days} شب اقامت</p>
            <div>
           <PersianNumber number={reserveinfodetail.amount} /> تومان
            </div>
        </div>
        <div className='d-flex-space  mb-[24px]'>
            <p>مجموع تخفیف</p>
            <div>
            ۰ تومان
            </div>
        </div>
        <div className='d-flex-space  mb-[24px]'>
            <p>جمع کل</p>
            <div>
           <PersianNumber number={reserveinfodetail.final_amount}/> تومان
            </div>
        </div>
        {/* <div className='d-flex-space'>
            <div className='PaymentTable--checkbox'>
            <input type="checkbox" id='1' />
                <label className='' htmlFor='1'>
                پرداخت از اعتبار کیف پول
                </label>
               

            </div>
            <div className='total-price'>
            ۲,۲۴۰,۰۰۰ تومان
            </div>

        </div> */}
    </div>
  )
}

export default PaymentTable